import { AxiosResponse } from 'axios';
import { Dashboard, Pagination } from '~/types';
import api from '~/utils/api';

export async function getDashboards(
  page: number,
  pageSize: number,
): Promise<Pagination<Dashboard>> {
  const { data } = await api.get<Pagination<Dashboard>>('/dashboards', {
    params: {
      page,
      size: pageSize,
    },
  });

  return {
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results,
  };
}

export async function atualizaExibirRelatorio(
  id: number,
  status: boolean,
): Promise<AxiosResponse<any>> {
  return api.post(`/dashboards/${id}/atualiza_exibir_relatorio`, {
    exibir_relatorio: status,
  });
}

export async function deleteDashboard(id: number): Promise<void> {
  await api.delete(`/dashboards/${id}`);
}

export async function getDashboardsAvailable(): Promise<Dashboard[]> {
  const { data } = await api.get('/dashboards/dashboards_available');
  return data;
}

export async function getDashboardById(id: string): Promise<Dashboard> {
  const { data } = await api.get<Dashboard>(`/dashboards/${id}`);
  return data;
}
